import React, { createContext, useContext, useState } from "react";
import {
  getUnreadCounts,
} from "../Services/notificationServices";
import toast from "react-hot-toast";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);


  // Fetch total unread count
  const fetchUnreadCount = async () => {
    try {
      const res = await getUnreadCounts();
      setUnreadCount(res.data.count || 0);
    } catch (err) {
      toast.error("Failed to fetch unread count");
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        unreadCount,
        setUnreadCount,
        fetchUnreadCount,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
